import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { DevelopmentTemplate } from '../../../services/Template/development-template';
import { useFormik } from 'formik';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Api } from '../../../services/api';
import { Accordion, AccordionTab } from 'primereact/accordion';
import "../PM TEMPLATE/PM_TEMPLATE.css";
import './DEVELOPMENT_MANAGER_TEMPLATE.css';
import { FaCopy, FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import { Toast } from 'primereact/toast';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Tooltip } from 'primereact/tooltip';
import WeeklyUpdatePreview from './WeeklyUpdatePreview';

// Module-level helper — stable reference, won't cause re-renders
const _adjustTextareaHeight = (textarea) => {
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
};

// Module-level textarea — local state prevents parent re-renders while typing
const LocalTextAreaField = React.memo(({ name, value, placeholder, rows = 2, onCommit, onDirty }) => {
    const [localValue, setLocalValue] = React.useState(value || '');
    const textareaRef = React.useRef(null);
    const onCommitRef = React.useRef(onCommit);
    const onDirtyRef = React.useRef(onDirty);

    React.useLayoutEffect(() => { onCommitRef.current = onCommit; });
    React.useLayoutEffect(() => { onDirtyRef.current = onDirty; });

    // Sync when external value changes (data load), not on local typing
    React.useEffect(() => { setLocalValue(value || ''); }, [value]);

    // Adjust height only on external value change
    React.useLayoutEffect(() => {
        if (textareaRef.current) _adjustTextareaHeight(textareaRef.current);
    }, [value]);

    const handleChange = React.useCallback((e) => {
        setLocalValue(e.target.value);
        onDirtyRef.current();
    }, []);

    const handleBlur = React.useCallback((e) => {
        onCommitRef.current(e.target.value);
    }, []);

    return (
        <textarea
            ref={textareaRef}
            name={name}
            id={name}
            rows={rows}
            placeholder={placeholder}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', paddingTop: '8px', paddingLeft: '5px', resize: 'none', overflow: 'hidden', fontFamily: 'inherit', fontSize: 'inherit', backgroundColor: 'transparent' }}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
});

const DEVELOPMENT_MANAGER_TEMPLATE = ({ pmId }) => {

    const [Milestones, setMilestones] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]);
    const [Section9Array, setSection9Array] = useState([{ name: '', }]);
    const [ProjectBudget, setProjectBudget] = useState([1, 2, 3, 4,]);
    const [Section6Array, setSection6Array] = useState([{ name: '', }]);
    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);
    const [isSaveBtnLoading, setIsSaveBtnLoading] = useState(false);
    const [showWeeklyPreview, setShowWeeklyPreview] = useState(false);
    const [previewValues, setPreviewValues] = useState(null);
    const [accordionActiveIndex, setAccordionActiveIndex] = useState([0, 1, 2, 3, 4]);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProjectDetails();

        return () => {
            if (existPageWithoutSave) {
                formik.handleSubmit();
            }
        };
    }, [pmId]);

    //! ----------------------------------------------------------
    const getProjectDetails = () => {
        var url = Api.API_BASE_URL + 'development/get';
        formik.setFieldValue('project_name', pmId);
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ projectId: pmId }),

        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error != '') {
                    formik.setFieldValue('dmId', 0);
                    if (Josn.projects.development_date) {
                        formik.setFieldValue(`section_3.0.plan_completion_date`, Josn.projects.development_date);
                        formik.setFieldValue(`section_3.29.plan_completion_date`, Josn.projects.receive_building_permit);
                        formik.setFieldValue(`section_3.29.current_forecast_completion_date`, Josn.projects.receive_building_permit_data);
                        formik.setFieldValue('projected_dp_date', Josn.projects.receive_building_permit_data);
                        formik.setFieldValue('purchase_close_date', Josn.projects.development_date);
                    }
                } else {

                    formik.setFieldValue('dmId', Josn.dm);

                    formik.setFieldValue('name', Josn.sec_1.name);
                    formik.setFieldValue('hereIsYourWeeklySummaryFrom', Josn.sec_2.hereIsYourWeeklySummaryFrom || '');
                    formik.setFieldValue('hereIsYourWeeklySummaryTo', Josn.sec_2.hereIsYourWeeklySummaryTo || '');

                    formik.setFieldValue('expected_date', Josn.sec_2.expected_date);
                    formik.setFieldValue('project_summary', Josn.sec_2.project_summary);
                    formik.setFieldValue('schedule', Josn.sec_2.schedule);
                    formik.setFieldValue('purchase_close_date', Josn.sec_2.purchase_close_date);
                    formik.setFieldValue('notes', Josn.sec_2.notes);
                    formik.setFieldValue('projected_dp_date', Josn.sec_2.projected_dp_date);
                    formik.setFieldValue('address_vp_comment', Josn.sec_2.address_vp_comment);
                    formik.setFieldValue('expected_date_vp_comment', Josn.sec_2.expected_date_vp_comment);
                    formik.setFieldValue('project_summary_vp_comments', Josn.sec_2.project_summary_vp_comments);

                    formik.setFieldValue('schedule_vp_comments', Josn.sec_2.schedule_vp_comments);

                    if (Josn.sec_3.length != 0) {
                        setMilestones(Josn.sec_3);
                        formik.setFieldValue('section_3', Josn.sec_3);
                    }

                    if (Josn.sec_4.length != 0) {
                        setSection9Array(Josn.sec_4);
                        formik.setFieldValue('section_4', Josn.sec_4);
                    }

                    if (Josn.sec_5.length != 0) {
                        setProjectBudget(Josn.sec_5);
                        formik.setFieldValue('section_5', Josn.sec_5);
                    }

                    if (Josn.sec_6.length != 0) {
                        setSection6Array(Josn.sec_6);
                        formik.setFieldValue('section_6', Josn.sec_6);
                    }
                    if (formik.values.section_3.length != 0) {

                        if (Josn.projects.development_date) {

                            if (formik.values.section_3[0].plan_completion_date == '0000-00-00') {
                                formik.setFieldValue(`section_3.0.plan_completion_date`, Josn.projects.development_date);
                            }
                    if (formik.values.section_3[29].plan_completion_date == '0000-00-00') {


                                formik.setFieldValue(`section_3.29.plan_completion_date`, Josn.projects.receive_building_permit_data);
                            }
                        }

                    }
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    const toast = useRef(null);
    const formik = useFormik({
        initialValues: DevelopmentTemplate.getFormName(),
        validate: (data) => {
        },
        onSubmit: (data) => {
            // if (!existPageWithoutSave) {
            //     return;
            // }

            setIsSaveBtnLoading(true);
            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');
            var url = Api.API_BASE_URL + 'development/save';

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setIsSaveBtnLoading(false);
                    setExistPageWithoutSave(false);
                    if (Josn.error != '') {
                        formik.setFieldValue('dmId', Josn.dm);
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        formik.setFieldValue('dmId', Josn.dm);
                    }
                })
                .catch((error) => {
                    setIsSaveBtnLoading(false);
                    console.error("Error:", error);
                });
        }
    });

    //! -----------------------

    //! ----------------------------------------------------------
    const priceBodyTemplatee = (rowData) => {

        if (rowData === '' || rowData === null) {
            return '';
        }
        let numberValue = Number(rowData);
        if (isNaN(numberValue)) {
            return '';
        }

        const isNegative = rowData < 0;
        return <span style={{ color: isNegative ? "red" : "black", textAlign: "center !important", }}>
            {formatCurrency(rowData)}
        </span>
    };
    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    // ----------------------------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <LocalTextAreaField
            name={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}
            placeholder={placeholder}
            rows={rowCount}
            onCommit={(val) => formik.setFieldValue(fieldName, val)}
            onDirty={() => setExistPageWithoutSave(true)}
        />
    );

    const renderTextAreaFull = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <LocalTextAreaField
            name={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}
            placeholder={placeholder}
            rows={rowCount}
            onCommit={(val) => formik.setFieldValue(fieldName, val)}
            onDirty={() => setExistPageWithoutSave(true)}
        />
    );

    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => {
        if (type == 'date') {
            if (formData != null) {
                let timestamp = new Date(formData);
                if (!isNaN(timestamp.getTime())) {
                    formData = timestamp.toISOString().split('T')[0];
                }
            }
        }
        let backgroundColor = '';
        if (fieldName === 'section_3.0.plan_completion_date') {
            backgroundColor = '#FFE1FF';
        } else if (fieldName === 'section_3.29.current_forecast_completion_date') {
            backgroundColor = '#FFCFB3';
        } else if (fieldName === 'section_3.29.plan_completion_date') {
            backgroundColor = '#FFEB55';
        }

        return (
            <InputText
                type={type}
                placeholder={placeholder}
                name={fieldName}
                id={fieldName}
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                    if (fieldName === 'section_3.0.plan_completion_date') {
                        formik.setFieldValue('purchase_close_date', e.target.value)
                    } else if (fieldName === 'section_3.29.current_forecast_completion_date') {
                        formik.setFieldValue('projected_dp_date', e.target.value)
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                    }
                }}
                className={classNames('w-full text-center border-none shadow-none')}
                style={{
                    width: '100%',
                    height: '40px',
                    boxSizing: 'border-box',
                    backgroundColor: backgroundColor,
                    borderRadius: 0
                }}
            />
        )
    };

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber

            inputId="currency-us"
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            placeholder="$0.00"
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.value)
            }
            }
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                textAlign: "center !important",
                marginTop: "0px",
                outline: 'none',
            }}
        />
    );


    const handleAddInputForMilestones = () => {
        setMilestones([...Milestones, 1]);
        formik.values.section_3.push(DevelopmentTemplate.getFormName().section_3[0]);
    };

    const handleDeleteInputForMilestones = (index) => {
        setMilestones([...Milestones, 2]);
        var newArray = [...Milestones];
        newArray.splice(index, 1);
        formik.values.section_3.splice(index, 1);
        setMilestones(newArray);
    };

    const handleAddInputForSection9Array = () => {
        setSection9Array([...Section9Array, { name: '', }]);
        formik.values.section_4.push({ activities_worked_on_this_week: '', contractor: '', brief_scope_of_work: '', current_f_c_date: '', vp_comments: '', });
    };

    const handleDeleteInputForSection9Array = (index) => {
        formik.values.section_4.splice(index, 1);
        setSection9Array([...Section9Array, { name: '', }]);
        const newArray = [...Section9Array];
        newArray.splice(index, 1);
        setSection9Array(newArray);
    };

    const handleAddInputForProjectBudget = () => {
        setProjectBudget([...ProjectBudget, 1]);
        formik.values.section_5.push(DevelopmentTemplate.getFormName().section_5[0]);
    };

    const handleDeleteInputForProjectBudget = (index) => {
        setProjectBudget([...ProjectBudget, 2]);
        var newArray = [...ProjectBudget];
        newArray.splice(index, 1);
        formik.values.section_5.splice(index, 1);
        setProjectBudget(newArray);
    };

    const handleAddInputForSection6Array = () => {
        setSection6Array([...Section6Array, { action_items_discussed: '', vp_comments: '' }]);
        formik.values.section_6.push({ action_items_discussed: '', vp_comments: '' });
    };

    const handleDeleteInputForSection6Array = (index) => {
        formik.values.section_6.splice(index, 1);
        setSection6Array([...Section6Array, { name: '', }]);
        const newArray = [...Section6Array];
        newArray.splice(index, 1);
        setSection6Array(newArray);
    };

    //* -------------------------
    const elementRef0 = useRef(null);
    const elementRef1 = useRef(null);
    const elementRef2 = useRef(null);
    const elementRef3 = useRef(null);
    const elementRef4 = useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const elementRefs = useMemo(() => [elementRef0, elementRef1, elementRef2, elementRef3, elementRef4], []);

    const expandAllTextareas = useCallback(() => {
        elementRefs.forEach(ref => {
            if (ref.current) {
                ref.current.querySelectorAll('textarea').forEach(_adjustTextareaHeight);
            }
        });
    }, [elementRefs]);

    //* -------------------------


    return (
        <div className="dm-template-container">
            <Toast ref={toast} />
            <WeeklyUpdatePreview
                visible={showWeeklyPreview}
                onHide={() => setShowWeeklyPreview(false)}
                values={previewValues}
            />
            {isLoading ? (
                <div className="dm-loading">
                    Loading...
                    <div className="dm-spinner"></div>
                </div>
            ) : (
                <form onSubmit={formik.handleSubmit} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div className="dm-template-card">
                        {/* ── Header ── */}
                        <div className="dm-template-header">
                            <h2 className="dm-template-title">Development Manager Playbook</h2>
                            <div className="dm-header-actions">
                                <Button className="dm-btn-copy" icon={<FaCopy />} label="Preview Weekly Update" type="button" onClick={() => { setPreviewValues(formik.values); setShowWeeklyPreview(true); }} />
                                <Button type="submit" className="dm-btn-save" icon={<FaSave />} label="SAVE" loading={isSaveBtnLoading} />
                            </div>
                        </div>

                        {/* ── Scrollable Body ── */}
                        <div className="dm-template-body">

                            <Accordion multiple activeIndex={accordionActiveIndex} onTabChange={(e) => setAccordionActiveIndex(e.index)}>

                            {/* ══════ Section 1: Development Manager Playbook ══════ */}
                            <AccordionTab header="1. DEVELOPMENT MANAGER PLAYBOOK">
                            <div className="dm-section" ref={elementRefs[0]}>

                                <div className="dm-table-wrap">
                                    <table className="dm-table">
                                        <tbody>
                                            <tr>
                                                <td className="dm-label-cell" style={{ width: '220px' }}>Name:</td>
                                                <td>{renderTextArea('name', '')}</td>
                                            </tr>
                                            <tr>
                                                <td className="dm-label-cell">Period:</td>
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span style={{ fontSize: '0.8125rem', fontWeight: 500, whiteSpace: 'nowrap' }}>From</span>
                                                        <input
                                                            type="date"
                                                            name="hereIsYourWeeklySummaryFrom"
                                                            value={formik.values.hereIsYourWeeklySummaryFrom || ''}
                                                            onChange={(e) => { setExistPageWithoutSave(true); formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value); }}
                                                        />
                                                        <span style={{ fontSize: '0.8125rem', fontWeight: 500, whiteSpace: 'nowrap' }}>To</span>
                                                        <input
                                                            type="date"
                                                            name="hereIsYourWeeklySummaryTo"
                                                            value={formik.values.hereIsYourWeeklySummaryTo || ''}
                                                            onChange={(e) => { setExistPageWithoutSave(true); formik.setFieldValue('hereIsYourWeeklySummaryTo', e.target.value); }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="dm-ref-card">
                                    <div className="dm-ref-card-header">
                                        <span className="dm-ref-card-title">Annual Deliverables</span>
                                        <span className="dm-ref-badge"><i className="pi pi-lock" style={{ fontSize: '0.65rem', marginRight: '4px' }} />Reference Only</span>
                                    </div>
                                    <div className="dm-ref-card-body">
                                        <div className="dm-ref-item">
                                            <div className="dm-ref-item-num">1</div>
                                            <div className="dm-ref-item-content">
                                                <div className="dm-ref-item-title">Identification of new developments</div>
                                                <div className="dm-ref-item-desc">To identify new development opportunities that fit into the Lida Group. This also means developing and maintaining relationships with industry professionals</div>
                                            </div>
                                            <span className="dm-ref-value-tag">We Are Team Players</span>
                                        </div>
                                        <div className="dm-ref-item">
                                            <div className="dm-ref-item-num">2</div>
                                            <div className="dm-ref-item-content">
                                                <div className="dm-ref-item-title">Analysis of highest and best use</div>
                                                <div className="dm-ref-item-desc">To review all new acquisitions for highest and best use. This encompasses determining the wants/needs of the various municipalities in order to not waste time pursuing plans that will not be approved</div>
                                            </div>
                                            <span className="dm-ref-value-tag">We Are Committed to Excellence</span>
                                        </div>
                                        <div className="dm-ref-item">
                                            <div className="dm-ref-item-num">3</div>
                                            <div className="dm-ref-item-content">
                                                <div className="dm-ref-item-title">Administration of the development process</div>
                                                <div className="dm-ref-item-desc">Organization and follow-up of the various stages of development including liasioning with consultants to push the project forward, submission of required paperwork, attending planning reviews, attending city council meetings, and reciept of building permits</div>
                                            </div>
                                            <span className="dm-ref-value-tag">We Do What We Say We Are Going To Do</span>
                                        </div>
                                        <div className="dm-ref-item">
                                            <div className="dm-ref-item-num">4</div>
                                            <div className="dm-ref-item-content">
                                                <div className="dm-ref-item-title">Schedule and budget</div>
                                                <div className="dm-ref-item-desc">Create, monitor and report on project schedule and budget paying particular attention to delays and unbudgeted expenses</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </AccordionTab>

                            {/* ══════ Section 2: Action Steps ══════ */}
                            <AccordionTab header="2. ACTION STEPS">
                            <div className="dm-section" ref={elementRefs[1]}>

                                <div className="dm-table-wrap">
                                    <table className="dm-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '220px' }}>Action Steps</th>
                                                <th>Development Manager Comments</th>
                                                <th>Companies Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="dm-label-cell">Expected Start Date:</td>
                                                <td>
                                                    <input
                                                        type="date"
                                                        name="expected_date"
                                                        id="expected_date"
                                                        value={formik.values.expected_date}
                                                        onChange={(e) => {
                                                            setExistPageWithoutSave(true);
                                                            formik.setFieldValue('expected_date', e.target.value);
                                                        }}
                                                    />
                                                </td>
                                                <td rowSpan={3}>{renderTextAreaFull('address_vp_comment', '', 2)}</td>
                                            </tr>
                                            <tr>
                                                <td className="dm-label-cell">Project Summary:</td>
                                                <td>{renderTextAreaFull('project_summary', '')}</td>
                                            </tr>
                                            <tr>
                                                <td className="dm-label-cell">Schedule:</td>
                                                <td style={{ padding: '8px 10px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ fontSize: '0.8125rem', fontWeight: 500, whiteSpace: 'nowrap' }}>Purchase close date</span>
                                                            <input
                                                                type="date"
                                                                name="purchase_close_date"
                                                                value={formik.values.purchase_close_date}
                                                                readOnly
                                                                className="dm-date-pink"
                                                                style={{ flex: 1 }}
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ fontSize: '0.8125rem', fontWeight: 500, whiteSpace: 'nowrap' }}>Projected DP date</span>
                                                            <input
                                                                type="date"
                                                                name="projected_dp_date"
                                                                value={formik.values.projected_dp_date}
                                                                readOnly
                                                                className="dm-date-green"
                                                                style={{ flex: 1 }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </AccordionTab>

                            {/* ══════ Section 3: Schedule Milestones ══════ */}
                            <AccordionTab header="3. SCHEDULE MILESTONES">
                            <div className="dm-section" ref={elementRefs[2]}>

                                <div className="dm-table-wrap">
                                    <table className="dm-table">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: '220px' }}>Schedule Milestones</th>
                                                <th style={{ width: '120px' }}>Planned<br />Completion Date</th>
                                                <th style={{ width: '120px' }}>Forecast<br />Completion Date</th>
                                                <th style={{ width: '120px' }}>Actual<br />Completion Date</th>
                                                <th style={{ minWidth: '120px' }}>
                                                    <span className="dm-notes-header" data-pr-tooltip="If applicable, explain why there was a change to the schedule" data-pr-position="top">
                                                        Notes <i className="pi pi-info-circle" style={{ fontSize: '0.7rem', marginLeft: '4px', opacity: 0.7 }} />
                                                    </span>
                                                    <Tooltip target=".dm-notes-header" />
                                                </th>
                                                <th>Companies Comments</th>
                                                <th style={{ width: '80px' }}>Add/Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Milestones.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{renderTextArea(`section_3.${index}.schedule_milestones`, '', 2, formik.values.section_3[index].schedule_milestones)}</td>
                                                    <td>{renderInputArea(`section_3.${index}.plan_completion_date`, '', 'date', formik.values.section_3[index].plan_completion_date)}</td>
                                                    <td>{renderInputArea(`section_3.${index}.current_forecast_completion_date`, '', 'date', formik.values.section_3[index].current_forecast_completion_date)}</td>
                                                    <td>{renderInputArea(`section_3.${index}.actual_completion_date`, '', 'date', formik.values.section_3[index].actual_completion_date)}</td>
                                                    <td>{renderTextAreaFull(`section_3.${index}.notes`, '', 2, formik.values.section_3[index].notes)}</td>
                                                    <td>{renderTextAreaFull(`section_3.${index}.vp_comments`, '', 2, formik.values.section_3[index].vp_comments)}</td>
                                                    <td className="dm-action-cell">
                                                        {index !== 0 && <FaTrash className="dm-btn-delete" onClick={() => handleDeleteInputForMilestones(index)} />}
                                                        {Milestones.length - 1 === index && <FaPlus className="dm-btn-add" onClick={() => handleAddInputForMilestones()} />}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </AccordionTab>

                            {/* ══════ Section 4: Activities Worked On This Week ══════ */}
                            <AccordionTab header="4. ACTIVITIES WORKED ON THIS WEEK">
                            <div className="dm-section" ref={elementRefs[3]}>

                                <div className="dm-table-wrap">
                                    <table className="dm-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '220px' }}>Activities (Description)</th>
                                                <th>Contractor</th>
                                                <th>Brief Scope of Work</th>
                                                <th>Current Forecasted Completion Date</th>
                                                <th>Companies Comments</th>
                                                <th style={{ width: '80px' }}>Add/Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Section9Array.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{renderTextAreaFull(`section_4.${index}.activities_worked_on_this_week`, '', 2, formik.values.section_4[index].activities_worked_on_this_week)}</td>
                                                    <td>{renderTextArea(`section_4.${index}.contractor`, '', 2, formik.values.section_4[index].contractor)}</td>
                                                    <td>{renderTextAreaFull(`section_4.${index}.brief_scope_of_work`, '', 2, formik.values.section_4[index].brief_scope_of_work)}</td>
                                                    <td>{renderInputArea(`section_4.${index}.current_f_c_date`, '', 'date', formik.values.section_4[index].current_f_c_date)}</td>
                                                    <td>{renderTextAreaFull(`section_4.${index}.vp_comments`, '', 2, formik.values.section_4[index].vp_comments)}</td>
                                                    <td className="dm-action-cell">
                                                        {Section9Array.length !== 1 && <FaTrash className="dm-btn-delete" onClick={() => handleDeleteInputForSection9Array(index)} />}
                                                        {Section9Array.length - 1 === index && <FaPlus className="dm-btn-add" onClick={() => handleAddInputForSection9Array()} />}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </AccordionTab>

                            {/* ══════ Section 5: Project Budget ══════ */}
                            <AccordionTab header="5. PROJECT BUDGET">
                            <div className="dm-section" ref={elementRefs[4]}>

                                <div className="dm-table-wrap">
                                    <table className="dm-table">
                                        <thead>
                                            <tr>
                                                <th>Project Budget</th>
                                                <th>Amount</th>
                                                <th>Companies Comments</th>
                                                <th style={{ width: '80px' }}>Add/Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ProjectBudget.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{renderTextArea(`section_5.${index}.project_budget`, '', 2, formik.values.section_5[index].project_budget)}</td>
                                                    <td>{renderInputAreaForAmount(`section_5.${index}.amount`, formik.values.section_5[index].amount)}</td>
                                                    <td>{renderTextAreaFull(`section_5.${index}.vp_comments`, '', 2, formik.values.section_5[index].vp_comments)}</td>
                                                    <td className="dm-action-cell">
                                                        {index !== 0 && <FaTrash className="dm-btn-delete" onClick={() => handleDeleteInputForProjectBudget(index)} />}
                                                        {ProjectBudget.length - 1 === index && <FaPlus className="dm-btn-add" onClick={() => handleAddInputForProjectBudget()} />}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Action Items Discussed */}
                                <div className="dm-table-wrap" style={{ marginTop: '16px' }}>
                                    <table className="dm-table">
                                        <thead>
                                            <tr>
                                                <th>Action Items Discussed</th>
                                                <th>Companies Comments</th>
                                                <th style={{ width: '80px' }}>Add/Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Section6Array.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{renderTextAreaFull(`section_6.${index}.action_items_discussed`, '', 2, formik.values.section_6[index].action_items_discussed)}</td>
                                                    <td>{renderTextAreaFull(`section_6.${index}.vp_comments`, '', 2, formik.values.section_6[index].vp_comments)}</td>
                                                    <td className="dm-action-cell">
                                                        {index !== 0 && <FaTrash className="dm-btn-delete" onClick={() => handleDeleteInputForSection6Array(index)} />}
                                                        {Section6Array.length - 1 === index && <FaPlus className="dm-btn-add" onClick={() => handleAddInputForSection6Array()} />}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </AccordionTab>

                            </Accordion>

                        </div>
                    </div>
                </form>
            )}
        </div>
    )
}

export default DEVELOPMENT_MANAGER_TEMPLATE
